import { DialogBody }          from '@/components/ui/dialog';
import { DialogCloseTrigger }  from '@/components/ui/dialog';
import { DialogContent }       from '@/components/ui/dialog';
import { DialogHeader }        from '@/components/ui/dialog';
import { DialogRoot }          from '@/components/ui/dialog';
import { DialogFooter }        from '@/components/ui/dialog';
import { DialogTitle }         from '@/components/ui/dialog';
import ApiModel                from '@widesk-core/models/ApiModel';
import React                   from 'react';
import { Button }              from '@/components/ui/button';
import { useTranslation }      from 'react-i18next';

export type ModalData = {
	model?: ApiModel;
	isDangerous?: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	titleComponent: React.ReactNode;
	bodyComponent: React.ReactNode;
	onConfirm?: (model?: ApiModel) => Promise<void>;
	onClose?: () => void;
	onError?: (error: unknown) => void;
	onSuccess?: () => void;
}

interface IModalProps {
	model?: ApiModel;
	isDangerous?: boolean;
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	titleComponent?: React.ReactNode;
	bodyComponent?: React.ReactNode;
	onConfirm?: (model?: ApiModel) => Promise<void>;
	onClose?: () => void;
	onError?: (error: unknown) => void;
	onSuccess?: () => void;
}

const Modal = (props: IModalProps) => {
	const { model, isDangerous, isOpen, setIsOpen, titleComponent, bodyComponent, onConfirm, onClose, onError, onSuccess } = props;

	const {t} = useTranslation();
	const [isLoading, setIsLoading] = React.useState(false);
	
	return (
		<DialogRoot open={isOpen} size={{ base: "xs", lg: "lg" }}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{titleComponent}</DialogTitle>
				</DialogHeader>
				<DialogBody pb="4">
					{bodyComponent}
				</DialogBody>
				{
					onConfirm &&
					<DialogFooter>
						<Button 
							onClick={() => setIsOpen(false)} 
							variant="outline"
						>
							{t('app.actions.cancel')}
						</Button>
						<Button 
							disabled={isLoading}
							bg={ isDangerous ? "red" : '' }
							color={ isDangerous ? "white" : '' }
							_hover={{ bg: isDangerous ? "red.500" : '' }} 
							onClick={async() => {
								try {
									setIsLoading(true);

									await onConfirm(model);

									if (onSuccess) {
										onSuccess();
									}

								} catch (error) {
									if (onError) {
										onError(error);
									}
									throw new Error(error as string);
								} finally {
									setIsLoading(false);
								}
							}}
						>
							{t('app.actions.confirm')}
						</Button>
					</DialogFooter>
				}
				<DialogCloseTrigger onClick={() => onClose && onClose()} />
			</DialogContent>
		</DialogRoot>
	)
}

export default Modal;